import { url } from "inspector";
import React, { useEffect, useState } from "react";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
import Success from "../../../../src/images/Sucess.json";
import axios from "axios";
import Lottie from "lottie-react";
import { ConnectorService } from "../../../base/service/apiServices";

function StoreToken() {
  let domainUrl: any = GetItemFromStorage("zendeskDomain");
  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const [loader, setLoader] = useState<boolean>(true);

  useEffect(() => {
    getToken();
  }, []);

  const getToken = async () => {
    const getCode = new URLSearchParams(window.location.search).get("code");

    let payloads = {
      domainUrl: domainUrl,
      domainId: loginUserCcaasDetail.domainId,
      code: getCode,
    };

    let endPoint = "zendesk/support/v1/callback"
    await ConnectorService.post(endPoint, payloads, "").then((response:any) => {

      if (response.statusCode == 200) {
        setLoader(true);
        window.opener.postMessage({ status: "success" }, "*");

        setTimeout(() => {
          window.close();
        }, 5000);

      } else {  
        setLoader(false);
        window.close();
        window.opener.postMessage({ status: "failure" }, "*");
      }
    }).catch((err)=>{
      console.log("err-----",err)
    })

    // let headers = {
    //   "Content-Type": "application/json",
    // };

    // await axios
    //   .post(
    //     "https://qaccaasapi.worktual.co.uk/connector/zendesk/support/v1/callback",
    //     payloads,
    //     { headers }
    //   )
    //   .then((resp) => {
    //     console.log("resp------------", resp.data);
    //     if (resp.data.statusCode == 200) {
    //       setLoader(true);
    //       window.opener.postMessage({ status: "success" }, "*");

    //       setTimeout(() => {
    //         window.close();
    //       }, 5000);

    //     } else {
          
    //       setLoader(false);
    //       window.opener.postMessage({ status: "failure" }, "*");

    //     }
    //   })
    //   .catch((err) => {
    //     console.log("err-----------", err);
    //   });
  };

  return (
    <div>
      {/* <p>Loading.....</p> */}

      {loader ? (
        <div className="connectorSuccess">
          <Lottie
            style={{ width: 530, margin: "0 auto" }}
            animationData={Success}
          />
          <h3>Connected Successfully</h3>
        </div>
      ) : (
        <h5>Sorry something Went Wrong!</h5>
      )}
    </div>
  );
}

export default StoreToken;
